export const DX_CUTOFF_COPY: Record<"dx" | "dxDropOff", string> = {
  dx: "DX collection cut-off: request your labels and have your order ready before 12pm (midday) to get next-day collection. Requests made after 12pm will be collected the following working day.",
  dxDropOff:
    "DX drop-off cut-off: request your labels and drop your order at your DX drop-off point before 4pm to get next-day collection. Drop-offs made after 4pm will be collected the following working day.",
};
